module.exports = __webpack_public_path__ + "img/p4.06dbb17e.png";